import React from 'react';
import { graphql } from 'gatsby';
import {
  StyledCards,
  StyledCard,
} from './styles';
import { uid } from 'react-uid';
import SectionHeader from '../SectionHeader';
import Section from '../Section';
import CheckSvg from '../../../assets/svg/icons/check.svg';
import SendGridLink from '../../SendGridLink';

const GlobalContentBlocksProductFeaturesBlock = ({ block }) => {

  return (
      <Section theme="tallGradient">
        <SectionHeader tagline={block.headline} title={block.subheadline} marginBottomTablet={'68px'} marginBottomMobile={'68px'}/>   
     
        {block.cards && (
            <StyledCards>            
              {block.cards.map((card) => (
                <StyledCard key={uid(card)}>
                  <div className="styled-card__inner">

                    <div className="styled-card__title-row">
                      {card.icon && (<img src={card.icon.sourceUrl} alt={card.icon.altText} />)}
                      <h2 dangerouslySetInnerHTML={{ __html: card.headline }} />
                    </div>

                    {card.listItems && (
                      <ul>
                        {card.listItems.map((item) => (
                          <li key={uid(item)}>
                            <figure>
                              <CheckSvg />
                            </figure>
                            <div dangerouslySetInnerHTML={{ __html: item.copy }} />
                          </li>
                        ))}
                      </ul>
                    )}

                    <SendGridLink
                      href={card.ctaLink}
                      className="arrow-link"
                      dangerouslySetInnerHTML={{ __html: card.ctaText }}
                    />

                  </div>
                </StyledCard>
              ))}
            </StyledCards>
          )}

          <div style={{ marginTop: "46px", fontSize: "12px",  fontWeight: "300" }}>{block.disclaimerText}</div>

      </Section>
  );
};

export default GlobalContentBlocksProductFeaturesBlock;

export const query = graphql`
  fragment ProductFeaturesBlockFragment on WPGraphQL_Page {
    acfGlobalContentBlocks {
      contentBlocks {
        ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_ProductFeaturesBlock {
          fieldGroupName
          headline
          subheadline
          disclaimerText
          cards {
            headline
            icon {
              altText
              sourceUrl
            }
            ctaLink
            ctaText
            listItems {
              copy
            }
          }
        }
      }
    }
  }
`;
